import api from "../services/api";

/**
 * Feature flags no frontend (Onda 0 do plano WABA) — espelha o backend.
 *
 * Fonte: GET /features (retorna as flags ativas DESTA instalação, lidas do
 * backend/instance-features.json). Chame loadFeatureFlags() após o login (uma
 * vez) e use isFeatureOn(key) para gatear botões/UI. Default OFF: sem carregar,
 * ou flag ausente, isFeatureOn retorna false — nada aparece por engano.
 *
 * ⚠️ Gate de UI apenas. A autoridade é o backend (assertFeatureOn nos envios);
 * esconder o botão é conveniência, não segurança.
 *
 * Manter WABA_FLAGS em sincronia com backend/src/helpers/FeatureFlags.ts.
 */

export const WABA_FLAGS = {
  CTA_URL: "waba-cta-url",
  ICE_BREAKERS: "waba-ice-breakers",
  TYPING: "waba-typing",
  BUSINESS_PROFILE: "waba-business-profile",
  CAROUSEL: "waba-carousel",
  AUTH_TEMPLATE: "waba-auth-template",
  CTWA_REFERRAL: "waba-ctwa-referral",
  ANALYTICS: "waba-analytics",
  BLOCK: "waba-block",
  FLOWS: "waba-flows",
  CATALOG: "waba-catalog",
  PAY: "waba-pay",
  CALLING: "waba-calling",
  CALL_AI: "call-intelligence",
  VOIP_PSTN: "voip-pstn"
};

const STORAGE_KEY = "featureFlags";

const readStored = () => {
  try {
    return new Set(JSON.parse(sessionStorage.getItem(STORAGE_KEY) || "[]"));
  } catch {
    return new Set();
  }
};

let activeFeatures = readStored();

/** Busca as flags da instalação e cacheia. Chamar após o login. */
export const loadFeatureFlags = async () => {
  try {
    const { data } = await api.get("/features");
    const list = data.features || [];
    activeFeatures = new Set(list);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    // avisa componentes já montados (ex.: menu lateral) p/ re-renderizar —
    // isFeatureOn é síncrono e não dispara re-render sozinho quando o load
    // assíncrono termina depois do 1º render.
    window.dispatchEvent(new Event("featureflags:loaded"));
  } catch (err) {
    // Fail-safe: mantém o cache anterior (ou vazio). Não quebra a UI.
  }
  return activeFeatures;
};

/** true se a flag estiver ligada nesta instalação (síncrono, pós-load). */
export const isFeatureOn = key => activeFeatures.has(key);
